import lateralBendingEn from "images/towers/lateral-bending-EN.gif"
import lateralBendingEs from "images/towers/lateral-bending-ES.gif"
import longitudinalBendingEn from "images/towers/longitudinal-bending-EN.gif"
import longitudinalBendingEs from "images/towers/longitudinal-bending-ES.gif"

/**
 * Locale-aware images referenceable from any plot `helpTooltip` via the
 * "img:<id>" convention (see `formatPlotTitleTooltip`). Each entry provides the
 * English and Spanish asset URLs; the current language picks which one renders.
 */
export const TOOLTIP_IMAGES: Record<string, { en: string; es: string }> = {
  "longitudinal-bending": { en: longitudinalBendingEn, es: longitudinalBendingEs },
  "lateral-bending": { en: lateralBendingEn, es: lateralBendingEs },
}

/** Prefix marking a `helpTooltip` item as an image id rather than an i18n key. */
export const TOOLTIP_IMAGE_PREFIX = "img:"
